import { Role, UserEntity } from '@/interfaces';
import { newQueryKeys } from '@/queries/queryKeys';
import { UserService } from '@/services';
import { getToken } from '@/utils';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useGetTenantQuery } from './useGetTenantQuery';

type UseGetProfileQueryOptions = Omit<
  UseQueryOptions<UserEntity, Error, UserEntity, any>,
  'queryKey' | 'queryFn'
>;

export const useGetMe = (options?: UseGetProfileQueryOptions) => {
  const { tenant } = useGetTenantQuery();

  const { id: tenantId } = tenant;

  const accessToken = getToken('accessToken');

  const query = useQuery({
    queryKey: newQueryKeys.profile.detail(accessToken),
    queryFn: UserService.getProfile,
    enabled: !!tenantId && !!accessToken,
    staleTime: Infinity,
    ...options,
  });

  return {
    ...query,
    data: query.data && {
      ...query.data,
      mainRole: query.data.roles?.reduce<Role | undefined>(
        (highest, role) =>
          !highest || role.level > highest.level ? role : highest,
        undefined,
      ),
    },
  };
};
